module.exports = __webpack_public_path__ + "img/to_robot.43d0df40.svg";